import type PricingArchitecture from '@app/model/pricing-automation/PricingArchitecture';
import type { PriceRecommendationState } from '@app/model/market_state/PriceRecommendationState';
import type { PriceEditGroup } from './PriceEditRoomsTable';

export const createRecommendationPriceEditGroups = (recommendationStates: PriceRecommendationState[], architectures: PricingArchitecture[]): PriceEditGroup[] | undefined => {
	const groups = recommendationStates.map((rwa, rwaIndex) => {
		const architecture = architectures.find(arch => arch.id === rwa.architectureId);
		if (architecture === undefined) return undefined;
		return {
			key: `reco-${rwa.id}`,
			rateIndex: rwaIndex,
			roomMappingType: rwa.roomMappingType,
			rooms: rwa.minimumBasePriceRoomStates.map((room, roomIndex) => {
				const rule = architecture.derivatives.find(der => der.pricingRoom.id === room.roomId)?.rule;
				return {
					roomId: room.roomId,
					roomName: room.roomName,
					isAnchor: room.isAnchor,
					currentPrice: Number(room.basePrice),
					derivativeRule: rule === undefined ? undefined : { type: rule.type, value: rule.value === null ? undefined : Number(rule.value) },
					roomIndex,
				};
			}),
		};
	});
	return groups.some(group => group === undefined) ? undefined : groups as PriceEditGroup[];
};
